var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gf_pricing__plan__row row"},_vm._l((_vm.dynamicContent.plans),function(content,key){return _c('div',{key:key,staticClass:"gf_pricing__plan__item",class:("col-" + (_vm.dynamicContent.plans &&
      (_vm.dynamicContent.plans.trial ||
        _vm.dynamicContent.plans.starter ||
        _vm.dynamicContent.plans.trial2022 || 
        _vm.dynamicContent.plans.development_store || 
        _vm.dynamicContent.plans.development || 
        _vm.dynamicContent.plans.development2022) 
        ? 3
        : 4))},[_vm._t("default",null,null,{content: content, key: key})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }